import { QueryClient, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api, ApiError } from "./api";

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 2,
      },
      mutations: { retry: false },
    },
  });
}

/** Ro'yxat: GET path?params → {items,total,...} */
export function useList(path, params, options = {}) {
  return useQuery({
    queryKey: [path, "list", params],
    queryFn: ({ signal }) => api.get(path, params, signal),
    placeholderData: (prev) => prev,
    ...options,
  });
}

export function useItem(path, id, options = {}) {
  return useQuery({
    queryKey: [path, "item", id],
    queryFn: ({ signal }) => api.get(`${path}/${id}`, undefined, signal),
    enabled: Boolean(id),
    ...options,
  });
}

export function useGet(path, params, options = {}) {
  return useQuery({
    queryKey: [path, "get", params],
    queryFn: ({ signal }) => api.get(path, params, signal),
    ...options,
  });
}

/**
 * Har qanday yozish amali: muvaffaqiyatda bog'liq so'rovlarni yangilaydi.
 * @param {(vars:any)=>Promise<any>} fn
 * @param {{ invalidate?: string[], onSuccess?: (data:any, vars:any)=>void }} [opts]
 */
export function useAction(fn, opts = {}) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: fn,
    onSuccess: (data, vars) => {
      // "/orders" → "/orders", "/orders/board", "/orders/123" kalitlari ham yangilanadi.
      const prefixes = [...(opts.invalidate ?? []), "/reports"];
      qc.invalidateQueries({
        predicate: (q) =>
          typeof q.queryKey[0] === "string" && prefixes.some((p) => String(q.queryKey[0]).startsWith(p)),
      });
      opts.onSuccess?.(data, vars);
    },
  });
}
